import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'select-addtolist',
  templateUrl: './select-add-to-list.component.html',
  styleUrls: ['./select-add-to-list.component.scss']
})
export class SelectAddToListComponent implements OnInit {

    @Input() title: string;
    @Input() list: [any];
    @Input() selectedItems = [];

    selected: any;

    constructor() {

    }

    ngOnInit(): void {
        
    }

    addItem() {
        //check item not already in list
        var alreadySelected = false;
        this.selectedItems.forEach((item) => {
            if (item.id == this.selected.id) {
                alreadySelected = true;
            }
        });

        if (!alreadySelected) {
            this.selectedItems.push(this.selected);
        }
    }

    removeItem(item: any) {
        var index = this.selectedItems.indexOf(item, 0);
        if (index > -1) {
            this.selectedItems.splice(index, 1);
        }
    }

}
